import { GiveawayStep } from 'swag-common/constants/giveaway.constants';
export const isGiveawayCompleted = step => {
  return step === GiveawayStep.completed;
};